module.exports = __webpack_public_path__ + "img/time-saas.76aab27b.png";